import type { FC, MouseEvent } from 'react';

import { Localization } from '../../Localization';
import { defaultTranslations } from '../../constants/defaultTranslations_simplified-registration-BrandPartner';
import { TranslationKey } from '../../models';
import { AnchorResend } from './VerificationStyledComponents';

interface IResendLinkComponent {
  handleResendCode: (event: MouseEvent) => void;
  isResendDisabled: boolean;
}

export const ResendLink: FC<IResendLinkComponent> = (props) => {
  const { handleResendCode, isResendDisabled } = props;

  if (isResendDisabled) {
    return (
      <Localization
        id={TranslationKey.resendInMinute}
        defaultMessage={defaultTranslations.resendInMinute}
      />
    );
  }

  return (
    <AnchorResend
      role="presentation"
      onClick={handleResendCode}
    >
      <Localization
        id={TranslationKey.PhoneVerification_SendAgain}
        defaultMessage={defaultTranslations.PhoneVerification_SendAgain}
      />
    </AnchorResend>
  );
};
